export function unwrapApiData(payload) {
  return payload?.data ?? payload;
}

export function extractCollection(payload) {
  const body = unwrapApiData(payload);

  if (Array.isArray(body)) return body;
  if (Array.isArray(body?.data)) return body.data;
  if (Array.isArray(body?.items)) return body.items;
  if (Array.isArray(body?.results)) return body.results;

  return [];
}

export function extractEntity(payload) {
  const body = unwrapApiData(payload);
  return body?.data ?? body;
}

export function getApiMessage(payload, fallback) {
  return payload?.message ?? payload?.data?.message ?? fallback;
}

export function getApiErrorMessage(error, fallback = 'Request failed.') {
  const data = error?.response?.data;

  if (typeof data?.message === 'string' && data.message.trim()) {
    return data.message;
  }

  if (data?.errors && typeof data.errors === 'object') {
    const first = Object.values(data.errors).flat().find(Boolean);
    if (first) return String(first);
  }

  if (error?.request) {
    return 'Unable to reach the server. Check the API address and network connection.';
  }

  return error?.message || fallback;
}
